// extracted by mini-css-extract-plugin
module.exports = {"modal-contacts-form":"styles-module__modal-contacts-form___3OdyH","modalContactsForm":"styles-module__modal-contacts-form___3OdyH"};